var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MeldungsvorlageElementRight',{attrs:{"vorlage_name_in":this.$parent.vorlage_name_in,"vorlage_menu_title":"Sortierung","is_editable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }